import { getBaseUrl } from '../BaseUrl';

// 엔드포인트 URL을 생성하는 함수의 타입을 정의합니다.
export interface GetBatteryListParams {
  page: number; // 필수
  size: number; // 필수
  identifier?: string; // 선택
  saleStatus?: string; // 선택
  carManufacturerId?: string; // 선택
  carModelId?: string; // 선택
  sortBy?: 'asc' | 'desc'; // 선택
  minPrice?: number; // 선택
  maxPrice?: number; // 선택
}

// SellerBatteryEndpointsProps 수정
export interface SellerBatteryEndpointsProps {
  get_battery_seller_damage_info: (batteryId: string) => string;
  put_battery_seller_damage_info_update: (batteryId: string) => string;
  delete_battery: () => string;
  put_battery_seller_sale_status: (batteryId: string) => string;
  put_battery_seller_representative_image: (batteryId: string) => string;
  put_battery_seller_qrcode: (batteryId: string) => string;
  get_battery_seller_list: (params: GetBatteryListParams) => string; // 수정
  post_battery_seller_register: () => string;
  get_battery_seller_measurements: (
    batteryId: string,
    page: number,
    size: number,
    category: string
  ) => string;
  post_battery_seller_measurements: (batteryId: string) => string;
  get_battery_seller_images: (
    batteryId: string,
    page: number,
    size: number
  ) => string;
  post_battery_seller_images: (batteryId: string) => string;
  get_battery_seller_sellers: (batteryId: string) => string;
  get_battery_seller_overview: (batteryId: string) => string;
  get_battery_seller_info: (batteryId: string) => string;
  get_battery_seller_models: (carModel: string) => string;
  get_battery_seller_manufacturers: () => string;
  get_battery_seller_manufacturer_models: (carManufacturerId: string) => string;
  get_battery_seller_data: () => string;
}

// SellerBatteryEndpoints 정의
export const SellerBatteryEndpoints: SellerBatteryEndpointsProps = {
  get_battery_seller_damage_info: (batteryId) =>
    `${getBaseUrl()}/batteries/${batteryId}`,
  put_battery_seller_damage_info_update: (batteryId) =>
    `${getBaseUrl()}/batteries/${batteryId}`,
  delete_battery: () => `${getBaseUrl()}/batteries`,
  put_battery_seller_sale_status: (batteryId) =>
    `${getBaseUrl()}/batteries/${batteryId}/sale-status`,
  put_battery_seller_representative_image: (batteryId) =>
    `${getBaseUrl()}/batteries/${batteryId}/representative-image`,
  put_battery_seller_qrcode: (batteryId) =>
    `${getBaseUrl()}/batteries/${batteryId}/qrcode`,
  get_battery_seller_list: (params) => {
    // 쿼리 파라미터 생성
    const queryParams = new URLSearchParams();

    // 필수 파라미터
    queryParams.append('page', params.page.toString());
    queryParams.append('size', params.size.toString());

    // 선택 파라미터 (조건부 추가)
    if (params.identifier) queryParams.append('identifier', params.identifier);
    if (params.saleStatus) queryParams.append('saleStatus', params.saleStatus);
    if (params.carManufacturerId)
      queryParams.append('carManufacturerId', params.carManufacturerId);
    if (params.carModelId) queryParams.append('carModelId', params.carModelId);
    if (params.sortBy) queryParams.append('sortBy', params.sortBy);
    if (params.minPrice !== undefined)
      queryParams.append('minPrice', params.minPrice.toString());
    if (params.maxPrice !== undefined)
      queryParams.append('maxPrice', params.maxPrice.toString());

    // URL 생성
    return `${getBaseUrl()}/batteries?${queryParams.toString()}`;
  },
  post_battery_seller_register: () => `${getBaseUrl()}/batteries`,
  get_battery_seller_measurements: (batteryId, page, size, category) =>
    `${getBaseUrl()}/batteries/${batteryId}/measurements?page=${page}&size=${size}&category=${category}`,
  post_battery_seller_measurements: (batteryId) =>
    `${getBaseUrl()}/batteries/${batteryId}/measurements`,
  get_battery_seller_images: (batteryId, page, size) =>
    `${getBaseUrl()}/batteries/${batteryId}/images?page=${page}&size=${size}`,
  post_battery_seller_images: (batteryId) =>
    `${getBaseUrl()}/batteries/${batteryId}/images`,
  get_battery_seller_sellers: (batteryId) =>
    `${getBaseUrl()}/batteries/${batteryId}/sellers`,
  get_battery_seller_overview: (batteryId) =>
    `${getBaseUrl()}/batteries/${batteryId}/overview`,
  get_battery_seller_info: (batteryId) =>
    `${getBaseUrl()}/batteries/${batteryId}/info`,
  get_battery_seller_models: (carModel) =>
    `${getBaseUrl()}/batteries/models/${carModel}`,
  get_battery_seller_manufacturers: () =>
    `${getBaseUrl()}/batteries/manufacturers`,
  get_battery_seller_manufacturer_models: (carManufacturerId) =>
    `${getBaseUrl()}/batteries/manufacturers/${carManufacturerId}/models`,
  get_battery_seller_data: () => `${getBaseUrl()}/batteries/data`,
};

export default SellerBatteryEndpoints;
